import { HTTP } from '../config/http-common';
import { ROUTE_API } from '../constants/routes';
import { exportResults } from '../utils/index';

export const finished = async (body) => exportResults(await HTTP.put(ROUTE_API.FINISH_SUB_LESSON, body));
